const Backbone = require('backbone');
const jsCookie = require('js-cookie');

const showRoomFinderUrl = 'https://www.fergusonshowrooms.com/page/find-a-location';

/**
 * This view is a temporary and needed for omnichannel in showrooms project.
 * Intention of this view is to find URL's on the page with 'https://www.fergusonshowrooms.com/page/find-a-location' links
 * and replace them with a new URL if a zipcode is available.
 * @example: https://www.fergusonshowrooms.com/decor/locationFinderWrapper.pl?zip=95928&radius=200&brand=SubZero/Wolf
 */
module.exports = Backbone.View.extend({
	el: '.js-page-content',
	initialize: function(options = {}) {
		this.radius = options.radius || 200;
		this.brand = options.brand || '';
		this.originalUrl = options.originalUrl || showRoomFinderUrl;
		const zipCode = jsCookie.get('postalCode');
		if (zipCode) {
			this._updateShowroomFinderUrls(this.originalUrl, zipCode);
		}
		// change listener from the universal location component.
		this.listenTo(Backbone, 'universalLocation:changed', this._handleLocationChange.bind(this));
	},
	_handleLocationChange(zipCode) {
		this._updateShowroomFinderUrls(this.originalUrl, zipCode);
	},
	_updateShowroomFinderUrls(oldUrl, zipCode) {
		if (zipCode) {
			const $linkstoShowroom = this.$el.find(`a[href^="${oldUrl}"]`);
			const newUrl = `https://www.fergusonshowrooms.com/decor/locationFinderWrapper.pl?zip=${zipCode}&radius=${this.radius}&brand=${this.brand}`;
			if ($linkstoShowroom.length) {
				$linkstoShowroom.each((i, linkToShowroom) => {
					$(linkToShowroom).attr('href', newUrl);
				});
				this.originalUrl = newUrl;
			}
		}
	}
});
